export default __webpack_public_path__ + "static/media/1091.83211548.png";